module.exports = __webpack_public_path__ + "img/contract_fq.036a03e3.png";